<app-slide-in-modal size="lg" #modal [layer]="layer()" (closed)="onClosed()">
  <ng-container title>
    <ng-container i18n>Résilier</ng-container> {{ title }}
  </ng-container>

  <div body>
    <form
      [formGroup]="form"
      class="lty-form letter-form"
      (submit)="$event.preventDefault()"
    >
      @if (step === 'form') {
        <div class="letter-group">
          <h3 class="letter-group__title" i18n>Demande</h3>
          <div class="split-form-body">
            <div class="form-group flex-basis-100">
              <label for="letter-policy" i18n>Police à résilier</label>
              <input
                id="letter-policy"
                type="text"
                class="form-control"
                [value]="policyLine"
                disabled
              />
            </div>
            <div class="form-group flex-basis-50">
              <label for="letter-customer" i18n>Client</label>
              <input
                id="letter-customer"
                type="text"
                class="form-control"
                [value]="cancellation?.userName ?? ''"
                disabled
              />
            </div>
            <div class="form-group flex-basis-50">
              <label for="letter-member" i18n>Membre de la famille</label>
              <input
                id="letter-member"
                type="text"
                class="form-control"
                [value]="cancellation?.memberName ?? ''"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="letter-group">
          <h3 class="letter-group__title" i18n>Envoi de la résiliation</h3>
          <div class="split-form-body">
            <div class="form-group letter-field--third">
              <label for="letter-send-method" i18n
                >Méthode d'envoi à la compagnie d'assurance</label
              >
              <div class="position-relative">
                <select
                  class="form-control"
                  id="letter-send-method"
                  formControlName="sendMethod"
                >
                  @for (method of sendMethods; track method) {
                    <option [value]="method">
                      {{ getCancellationSendMethodLabel(method) }}
                    </option>
                  }
                </select>
                <i class="bi bi-chevron-down edge-element"></i>
              </div>
            </div>
            <div class="form-group letter-field--third">
              <label for="letter-date" i18n>Date de la lettre</label>
              <input
                class="form-control"
                type="date"
                id="letter-date"
                formControlName="letterDate"
              />
            </div>
            <div class="form-group letter-field--third">
              <label for="letter-cancellation-date" i18n
                >Date de résiliation</label
              >
              <input
                class="form-control"
                type="date"
                id="letter-cancellation-date"
                formControlName="cancellationDate"
              />
            </div>
          </div>
        </div>

        @if (mode === 'GENERATE') {
          <div class="letter-group">
            <h3 class="letter-group__title" i18n>
              Informations complémentaires
            </h3>
            <textarea
              class="form-control letter-note"
              id="letter-note"
              formControlName="note"
              placeholder="Précisions à transmettre à la compagnie…"
              i18n-placeholder
            ></textarea>
          </div>
        }

        <div class="letter-group">
          <h3 class="letter-group__title" i18n>Lettre de résiliation</h3>
          <div class="letter-options">
            <label
              class="letter-option"
              [class.letter-option--chosen]="mode === 'IMPORT'"
            >
              <span class="letter-option__choice">
                <input
                  type="radio"
                  class="letter-option__radio"
                  formControlName="mode"
                  value="IMPORT"
                />
                <span class="letter-option__label" i18n
                  >Importer la lettre signée</span
                >
              </span>
              <app-file-input accept="application/pdf" formControlName="file" />
              @if (
                form.controls.file.value && form.controls.file.errors?.['pdf']
              ) {
                <span class="letter-option__error" i18n
                  >Seul un PDF peut être importé</span
                >
              }
            </label>

            <label
              class="letter-option"
              [class.letter-option--chosen]="mode === 'GENERATE'"
            >
              <span class="letter-option__choice">
                <input
                  type="radio"
                  class="letter-option__radio"
                  formControlName="mode"
                  value="GENERATE"
                />
                <span class="letter-option__label" i18n>Générer la lettre</span>
              </span>
              <span class="letter-option__hint" i18n>
                LTY rédige la lettre à partir des informations de la police.
                Vous la relisez avant envoi.
              </span>
              <button
                type="button"
                class="lty-btn lty-btn-white letter-option__print"
                [disabled]="mode !== 'GENERATE' || !canGenerate"
                (click)="preview()"
              >
                <app-eye-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-500)"
                />
                <ng-container i18n>Voir</ng-container>
              </button>
            </label>
          </div>
        </div>
      } @else {
        <div class="letter-group">
          <h3 class="letter-group__title" i18n>E-mail au client</h3>
          <div class="split-form-body">
            <div class="form-group flex-basis-50">
              <label for="letter-recipient" i18n>Destinataire</label>
              <input
                class="form-control"
                type="text"
                id="letter-recipient"
                [value]="recipientEmail"
                [placeholder]="renderLoading ? loadingText : ''"
                readonly
              />
            </div>
            <div class="form-group flex-basis-50">
              <label for="letter-subject" i18n>Objet</label>
              <input
                class="form-control"
                type="text"
                id="letter-subject"
                formControlName="subject"
                [placeholder]="renderLoading ? loadingText : ''"
              />
            </div>
            <!-- `modalOpen` is a TinyMCE lifecycle gate; see `ComposeModalBase`. -->
            @if (modalOpen) {
              <div class="form-group flex-basis-100">
                <label i18n>Corps du mail</label>
                <editor
                  formControlName="body"
                  [plugins]="editorPlugins"
                  [toolbar]="editorToolbar"
                />
              </div>
            }
          </div>
        </div>
      }
    </form>
  </div>

  <div class="modal-submit-buttons" footer>
    @if (step === 'email') {
      <button
        type="button"
        class="lty-btn lty-btn-white ms-auto"
        (click)="backToForm()"
        i18n
      >
        Retour
      </button>
      <button
        type="button"
        class="lty-btn lty-btn-primary"
        [disabled]="!canSendEmail"
        (click)="sendByEmail()"
        i18n
      >
        Envoyer
      </button>
    } @else {
      <button
        type="button"
        class="lty-btn lty-btn-white ms-auto"
        (click)="closeModal()"
        i18n
      >
        Annuler
      </button>
      @if (mode === 'IMPORT') {
        <button
          type="button"
          class="lty-btn lty-btn-primary"
          [disabled]="!canImport"
          (click)="importSigned()"
          i18n
        >
          Valider
        </button>
      } @else {
        <button
          type="button"
          class="lty-btn lty-btn-primary"
          [disabled]="!canGenerate"
          (click)="openEmailStep()"
          i18n
        >
          Envoyer par mail au client
        </button>
        <button
          type="button"
          class="lty-btn lty-btn-primary"
          [disabled]="!canGenerate"
          (click)="sendByPost()"
          i18n
        >
          Enregistrer
        </button>
      }
    }
  </div>
</app-slide-in-modal>
